import { queryOptions, useQuery } from "@tanstack/react-query";
import { get } from "lodash";
import { apiBase } from "../utils/apiBase";
import { queryClient, REFERENCE_QUERY_OPTIONS } from "./queryClient";

export const entitiesQuery = queryOptions({
  queryKey: ["entities"],
  queryFn: () =>
    apiBase.get("entities").then((res) => get(res, "data.entities", [])),
  ...REFERENCE_QUERY_OPTIONS,
  meta: { errorMessage: "Failed to load entities." },
});

export const useEntities = () => useQuery(entitiesQuery);
export const invalidateEntities = () =>
  queryClient.invalidateQueries({ queryKey: entitiesQuery.queryKey });
